const mastermindFaqs = [
  {
    question: "What is the Generative AI Mastermind?",
    answer:
      "The Mastermind sessions are conducted on Saturday and Sunday from 10AM to 8PM IST. You can reach out to hi@outskill.com for exact dates!",
  },
  {
    question: "How will the mastermind sessions be conducted?",
    answer:
      "All sessions are conducted live via Zoom. Participants will also engage in breakout room activities for practical implementation in small groups.",
  },
  {
    question: "Is the event completely online?",
    answer:
      "Yes, the mastermind is entirely online, allowing participants to join from anywhere via Zoom.",
  },
  {
    question: "Why can't I receive a recording of the sessions?",
    answer:
      "Since the mastermind includes live breakout room activities and real-time implementation, recordings won't capture the full experience. Attending live ensures you gain the most value.",
  },
  {
    question: "What happens if I can't attend on the scheduled dates?",
    answer:
      "If you're unable to attend, you can defer your enrollment to the next mastermind session scheduled. Recordings, however, won't be provided.",
  },
  {
    question: "Is there any preparation needed before the event?",
    answer:
      "Yes, attending the kick-off call on Friday at 7PM IST is mandatory as we will guide you in setting up the tools needed for the mastermind.",
  },
  {
    question: "Can I participate if I'm new to Generative AI?",
    answer:
      "Absolutely! The event covers both foundational concepts and advanced techniques, making it suitable for beginners and experienced users alike",
  },
  {
    question:
      "What specific AI skills and tools will I learn, and how are they applicable in real-world scenarios?",
    answer: (
      <>
        <p>
          Here&apos;s a breakdown of what you&apos;ll learn and how you&apos;ll
          use it:
        </p>
        <ul className="list-disc list-inside">
          <li>
            ChatGPT & OpenAI Playground: Prompt engineering and AI output
            optimization.
          </li>
          <li>Claude AI: Web application generation.</li>
          <li>
            ControlNet & IP-Adapter: Precision control in diffusion-based image
            generation.
          </li>
          <li>
            Runway ML, Midjourney, Topaz, Magnific, Leonardo, Luma Dream
            Machine: Ad creation and visual storytelling.
          </li>
          <li>Agentive AI: Custom GPT creation and AI agent development.</li>
          <li>
            Make.com: Email automation and social media content posting via
            OpenAI API.
          </li>
        </ul>
      </>
    ),
  },
  {
    question:
      "How much time commitment is required beyond the scheduled sessions to fully benefit from the challenge?",
    answer:
      "A total of 16 hours is what is required - 8 hours on Saturday & 8 hours on Sunday",
  },
  {
    question:
      "What kind of support will be provided post-event to help implement the learned skills?",
    answer:
      "As part of the mastermind, you'll gain access to an exclusive community that stays active beyond the two-day event. This community serves as your go-to resource for continued learning, peer support and expert guidance.",
  },
  {
    question:
      "How interactive are the sessions, and will there be opportunities for personalized feedback?",
    answer:
      "The sessions are fully live and designed to be highly interactive. After every session, participants are divided into breakout rooms for hands-on practice with the tools and workflows taught for personalized feedback and real-time problem-solving.",
  },
  {
    question:
      "Are there any prerequisites or technical requirements needed to participate effectively in the challenge?",
    answer:
      "No prerequisites are required—just come with an open mind and curiosity to learn. Everything else will be covered during the challenge, right from the basics!",
  },
  {
    question:
      "What happens if the tools or skills taught become outdated due to rapid technological advancement?",
    answer:
      "The mastermind is fully live, ensuring all content is updated and relevant to the current AI landscape. Content is refreshed as and when needed to keep up with advancements.",
  },
  {
    question:
      "Can the sessions accommodate different time zones, especially for international participants?",
    answer:
      "Yes, we accommodate international participants with separate sessions scheduled in EST timezone, ensuring accessibility for a global audience.",
  },
  {
    question:
      "What are the credentials or backgrounds of the instructors leading the sessions?",
    answer:
      "The mentors are from leading AI agencies and companies at the forefront of the AI revolution, bringing real-world expertise and credibility to the sessions.",
  },
  {
    question:
      "Is there a certificate of completion provided at the end of the challenge?",
    answer:
      "Yes, a completion certificate is provided to participants at the end of the mastermind.",
  },
  {
    question:
      "How can this training help in securing job promotions or new opportunities?",
    answer:
      "By mastering Generative AI concepts and workflows, this training makes you a 10x more efficient professional across any domain, helping you stand out for promotions and new opportunities.",
  },
  {
    question:
      "Are there any ongoing community or networking opportunities for past participants?",
    answer:
      "Yes, you'll gain lifetime access to the mastermind community channels, providing continuous learning and networking opportunities even after the event.",
  },
  {
    question:
      "What if I have limited experience with AI or technical tools—will this challenge be overwhelming?",
    answer:
      "No, this challenge is a perfect introduction to Generative AI tools and workflows, designed to be accessible for beginners.",
  },
  {
    question: "How can I measure my improvement in AI skills post-challenge?",
    answer:
      "After every session, you'll work on hands-on workbooks in breakout rooms, allowing you to practice, measure, and refine your skills in Generative AI.",
  },
  {
    question:
      "Are there any discounts available for early registration or group enrollments?",
    answer:
      "Early registrations are priced at INR 4999/-. For corporate training or group enrollments, email us at hi@outskill.com for a customized plan.",
  },
  {
    question:
      "Will the challenge content be updated to reflect the latest AI trends?",
    answer:
      "Yes, the content of the Mastermind is always up-to-date, reflecting the latest AI trends and advancements.",
  },
  {
    question:
      "How do the breakout sessions work, and what if I prefer one-on-one interaction?",
    answer:
      "Breakout sessions let you connect with like-minded participants and practice the workflows taught, providing hands-on exposure. For one-on-one interaction, you'll have opportunities within these breakout rooms to engage directly.",
  },
  {
    question:
      "Can I defer my enrollment more than once if personal circumstances change?",
    answer:
      "We allow one-time-deferral into a later batch. As seats in every mastermind are limited, we would need you to confirm your participation in advance.",
  },
  {
    question:
      "What kind of projects or exercises will be included in the workbook?",
    answer:
      "We have different activities based on every session of the mastermind. You will be building a web based app, a video, a Custom GPT & an AI Automation - throughout all the sessions of the mastermind.",
  },
  {
    question:
      "Are there specific case studies or success stories from past participants?",
    answer:
      "You can find snippets of the learnings & experience the previous participants had in the testimonials section of this page.",
  },
  {
    question:
      "What happens if technical difficulties prevent me from attending a session?",
    answer:
      "You can request for a deferral to the next batch of the mastermind.",
  },
  {
    question:
      "Will there be opportunities for collaboration or forming teams during sessions?",
    answer:
      "Yes - you will have such opportunities in the form of breakout rooms.",
  },
  {
    question:
      "How do I choose between focusing on foundational skills versus advanced techniques?",
    answer:
      "A thorough understanding of the foundational concepts is very important before even considering advanced techniques. As Generative AI evolves, it is very crucial to learn the science & foundations of how these models work for long-term success.",
  },
  {
    question:
      "Is there a refund policy if I'm unable to participate after enrollment?",
    answer:
      "We do not have a refund policy. However, you can defer your enrolment into a later batch once.",
  },
  {
    question:
      "What tools or software should I have ready before the challenge begins?",
    answer:
      "Ensure access to the following tools for a seamless experience:- ChatGPT, Claude AI, ControlNet, IP-Adapter, OpenAI Playground, Runway ML, Midjourney, Topaz, Magnific, Leonardo, Luma Dream Machine, Agentive AI & Make.com",
  },
  {
    question:
      "How are attendees selected if the number exceeds the available spots?",
    answer:
      "We cap the number of participants to ensure a high-quality, interactive experience. Once spots are filled, new registrations may need to defer to a future batch.",
  },
  {
    question:
      "How can I continue my AI learning journey after the challenge concludes?",
    answer:
      "The Mastermind gives you a strong foundation and sparks curiosity for further learning. Post-challenge, you'll have access to a community of AI enthusiasts to share knowledge, explore tools, and grow together.",
  },
];

const fellowshipFaqs = [
  {
    question:
      "When are the classes scheduled? Will they be on weekdays or weekends?",
    answer:
      "Classes are scheduled over the weekends to maximize convenience for working professionals. You'll need to commit around 8 hours on weekends to engage fully with the material. During the week, plan for approximately 2-3 additional hours to complete assignments and reinforce what you've learned. We might have some optional guest sessions and keynotes happening on the weekdays.",
  },
  {
    question: "Will recordings of the sessions be provided?",
    answer:
      "Yes, recordings of each session will be made available on the LMS we provide. This allows you to revisit the material at your convenience and catch up on any sessions you might have missed.",
  },
  {
    question: "Will I have mentors guiding me throughout the cohort?",
    answer:
      "While you will not have direct, continuous mentorship, you will have teaching assistants (TAs) assigned to support you throughout the program. They will be available to answer questions, provide guidance on assignments, and help you stay on track with the learning objectives.",
  },
  {
    question: "Will I be able to build something by the end of this cohort?",
    answer:
      "Yes, this program is designed to empower you to create AI-based solutions by the end of the cohort. If your goal is to build something, you'll gain the skills, knowledge, and practical experience necessary to bring your project ideas to life using AI.",
  },
  {
    question: "I'm not a coder. Will I still benefit from this cohort?",
    answer:
      "Absolutely. This program is structured to be accessible to non-coders. You'll learn fundamental AI concepts without needing a technical background, and we'll teach you how to leverage prompts and no-code or low-code tools to apply AI in your work.",
  },
  {
    question:
      "Do I need a high-performance laptop to complete the AI use-cases in this program?",
    answer:
      "No, a high-performance laptop is not a requirement. Your current laptop should be more than sufficient to handle the AI tools and projects we'll cover in the program.",
  },
  {
    question: "Is access to the AI community limited to six months?",
    answer:
      "No, you'll enjoy lifetime access to the AI community, allowing you to continue networking, learning, and collaborating with fellow cohort members long after the program concludes.",
  },
  {
    question: "How long will I have access to the cohort recordings?",
    answer:
      "You will have access to all session recordings on the LMS for one full year after the cohort ends. This gives you ample time to review the material and reinforce your learning at your own pace",
  },
  {
    question:
      "I'm a business owner and don't think I'll have enough time to participate. Can I still benefit from the program?",
    answer:
      "That's completely understandable. If you're unable to commit the time yourself, I'd recommend enrolling a team member instead. They can gain the skills from the program and bring back the insights to your business. We will conduct an interview with them as well to ensure a good fit for the program.",
  },
  {
    question: "How can I enrol for the program?",
    answer:
      "You can't enrol for the program directly. Kindly register your interest and a member of the team will reach out and check your fitment for the program.",
  },
];

const engineerFaqs = [
  {
    question: "Who is this program for?",
    answer:
      "Software developers, ML engineers, and AI professionals looking to advance their careers.",
  },
  {
    question: "Do I need AI experience?",
    answer:
      "Yes, recordings of each session will be made available on the LMS we provide. This allows you to revisit the material at your convenience and catch up on any sessions you might have missed.",
  },
  {
    question: "Will I have mentors guiding me throughout the cohort?",
    answer:
      " Basic programming knowledge is required; AI expertise is helpful but not mandatory.",
  },
  {
    question: "What will I build in the capstone project?",
    answer:
      " A production-ready AI-powered application integrating LLMs, automation, and cloud deployment.",
  },
  {
    question: " Is the program self-paced?",
    answer:
      " It's a hybrid model—live weekend sessions with self-paced modules.",
  },
  {
    question: " How do I apply for a scholarship?",
    answer:
      "Submit an application outlining your background and motivation for joining.",
  },
  {
    question: " What happens after the program?",
    answer:
      "Gain access to job opportunities, a strong AI network, and career support.",
  },
];

 const engineerMastermindFaqs = [
   {
     question: "Do I need prior AI experience to join this workshop?",
     answer:
       " Basic programming knowledge (preferably Python) is required, but no advanced AI experience is necessary. We'll guide you from fundamentals to advanced implementations.",
   },
   {
     question: "How will the workshop sessions be conducted?",
     answer:
       " All sessions are LIVE via Zoom with interactive coding, real-time Q&A, and hands-on project implementation. This is not a passive webinar - you'll be building real AI systems.",
   },
   {
     question: "Will I receive recordings of the sessions?",
     answer:
       " No, to ensure maximum engagement and protect proprietary techniques, we don't provide recordings. This workshop is designed for active participation and implementation.",
   },
   {
     question: "What makes this different from other AI workshops?",
     answer:
       "  Unlike theoretical courses, our workshop focuses on building production-ready AI systems. You'll implement actual RAG systems and agentic AI solutions that solve real engineering problems.",
   },
   {
     question:
       " Will I be able to apply these skills immediately after the workshop?",
     answer:
       "  Absolutely. Every technique taught is designed for immediate implementation. Our engineers typically deploy their first AI system within a week of completing the workshop.",
   },
   {
     question: " Is there post-workshop support available?",
     answer:
       " Yes, you'll get access to our private community where mentors provide guidance for 30 days after the workshop.",
   },
   {
     question: " What if I can't attend the full workshop?",
     answer:
       " We strongly recommend attending all sessions as each builds on previous knowledge. However, we understand emergencies happen and will do our best to help you catch up.",
   },
   {
     question: " What if I can't attend the full workshop?",
     answer:
       " We strongly recommend attending all sessions as each builds on previous knowledge. However, we understand emergencies happen and will do our best to help you catch up.",
   },
   
 ];
 
const toolsFaqs = [
  {
    question: "What is this program about?",
    answer:
      "A step-by-step guide to master AI tools and turn your skills into income.",
  },
  {
    question: "Who is it for?",
    answer:
      "Freelancers, professionals, creators, and students—no tech background needed.",
  },
  {
    question: "What tools will I learn?",
    answer:
      "20+ tools like ChatGPT, Claude, Gemini, Notion AI, Zapier, and more.",
  },
  {
    question: "Do I need to know coding?",
    answer: "No. It’s beginner-friendly with no-code and low-code tools.",
  },
  {
    question: "How can I earn from this?",
    answer:
      "Through freelancing, AI services, product creation, and consulting.",
  },
  {
    question: "Is it live or self-paced?",
    answer:
      "Self-paced modules with optional live sessions and community support.",
  },
  {
    question: "What makes it unique?",
    answer:
      "It goes beyond tool training—into real workflows and monetization strategies.",
  },
  {
    question: "How long does it take to complete?",
    answer: "You can complete it in 4–6 weeks, depending on your pace.",
  },
  {
    question: "Is there a certificate?",
    answer: "Yes, you’ll get a certificate upon completion.",
  },
  {
    question: "What’s the fee?",
    answer:
      "₹1,00,000 for full access, templates, tools, and monetization playbooks.",
  },
];

const bootcampFaqs = [
  {
    question:
      "When are the classes scheduled? Will they be on weekdays or weekends? ",
    answer:
      "Weekdays (Mon-Fri): 7:30 PM to 11:00 PM IST | Weekends (Sat-Sun): 10:00 AM to 7:00 PM IST",
  },
  {
    question: "Will recordings of the sessions be provided? ",
    answer:
      "Yes, all sessions are recorded and available for 12 months after program completion.",
  },
  {
    question: "How much hands-on practice will I get during the program?",
    answer:
      "70% of the training is hands-on, plus 30+ additional hours of pure practice during office hours.",
  },
  {
    question:
      "Will I be able to build real AI projects by the end of this program?",
    answer:
      "Yes, you'll build multiple functioning AI applications and complete projects with mentor guidance.",
  },
  {
    question: "I'm not technical. Will I still benefit from this AI training? ",
    answer:
      "Absolutely! Our program is designed for both technical and non-technical professionals with no coding experience required.",
  },
  {
    question:
      "Do I need a high-performance computer to complete the AI projects in this program? ",
    answer: "A standard laptop is sufficient.",
  },
  {
    question: " How is this different from other AI courses available online",
    answer:
      "We focus on building real applications with industry experts, combining structured learning with personalized mentorship.",
  },
  {
    question: "Will I have mentors guiding me throughout the 14 days?",
    answer:
      "Yes, industry experts guide the 7-day training, plus dedicated mentorship during the 30+ hours of office hours",
  },
  {
    question:
      "What's the difference between the 7-day program and the 14-day program?",
    answer:
      "The 14-day program includes everything in the 7-day training plus 30+ hours of mentor-guided project development.",
  },
  {
    question: "How long will I have access to the training recordings? ",
    answer:
      "12 months from the program end date, giving you ample time to revisit and perfect your skills.",
  },
  {
    question:
      "I'm a busy professional with limited time. Can I still benefit from the program? ",
    answer:
      "Yes, our evening/weekend schedule and recordings are designed for busy professionals to maximize learning with minimal disruption.",
  },
];

const acceleratorFaqs = [
  {
    question: "What is the AI Generalist Accelerator Program?",
    answer:
      "It's a fast-paced, high-impact program designed to help individuals become full-stack AI generalists with a deep understanding of AI tools, workflows, business acumen, and monetization techniques.",
  },
  {
    question: "Who should enroll in this program?",
    answer:
      "Entrepreneurs, working professionals, consultants, agency owners, and freelancers who want to upskill in generative AI.",
  },
  {
    question: "Is this program suitable for beginners?",
    answer:
      "Yes, the program is designed to guide beginners to advanced learners, helping anyone develop a generalist mindset in AI.",
  },
  {
    question:
      "Can this program help me transition into a new AI-driven career?",
    answer:
      "Absolutely! The program equips you with skills to move into AI-centric roles, whether you're starting from scratch or have prior experience.",
  },
  {
    question: "How much time do I need to dedicate to the program?",
    answer:
      "You should expect to dedicate 40+ hours during the 7-day intensive and additional time for project work and live sessions over the year.",
  },
  {
    question: "Is there any prerequisite knowledge required?",
    answer:
      "No, but familiarity with basic computer skills and a willingness to learn about AI tools will be beneficial.",
  },
  {
    question: "What makes this program different from other AI courses?",
    answer:
      "This program provides a unique blend of AI technical training, business acumen, and monetization strategies, all tailored to diverse professional backgrounds.",
  },
  {
    question: "Will I receive a certificate upon completion?",
    answer:
      "Yes, a certificate will be provided after successful completion of the program.",
  },
  {
    question: "How long is the program in total?",
    answer:
      "The core intensive is 7 days, followed by 7 days of office hours, with ongoing live sessions for the next year.",
  },
  {
    question: "What is the format of the learning?",
    answer:
      "The program is hands-on with practical assignments, live sessions, and access to a content library.",
  },
];

const engAcceleratorFaqs = [
  {
    question: "What is the AI Engineering Accelerator Program?",
    answer:
      "It's an intensive 14-day bootcamp designed to transform developers and engineers into full-stack AI Engineers. The program focuses on building production-ready AI systems, deploying real applications, and mastering enterprise-level AI tools through hands-on engineering projects.",
  },
  {
    question: "Is coding background needed?",
    answer: "Yes, basic coding understanding is needed.",
  },
  {
    question: "How much time do I need to dedicate for this program?",
    answer:
      "You should expect to dedicate 70+ hours during the intensive 14-day bootcamp. This includes live engineering training sessions, hands-on labs, and project work where you'll build 7+ real AI applications.",
  },
  {
    question: "Will I receive a certificate upon completion?",
    answer:
      "Yes, a certificate will be provided after successful completion of the program.",
  },
  {
    question: "What is the format of the learning?",
    answer:
      "The program combines live instruction with hands-on labs in an intensive bootcamp format. You'll work on real projects, deploy production-ready systems, and gain practical experience with enterprise AI tools through guided sprints.",
  },
  {
    question: "What will I build during the program?",
    answer: `You'll create 7+ production-ready AI applications including:
    - Your own ChatGPT-level application
    - Automated job search and application system
    - Personal AI assistant (RAG systems)
    - Multi-modal AI systems
    - AI agents and autonomous systems
    - Multi-agent collaborative systems
    - Plus a capstone project of your choice.`,
  },
];

const businessFaqs = [
  {
    question: "What is the Outskill for Business program?",
    answer:
      "A fully customised corporate AI training program, delivered live, on-site, offsite or blended. We design the curriculum around your team's roles, your tech stack and your business KPIs. You get practitioner-led sessions, hands-on projects, a dedicated program manager and a complete outcomes report at the end.",
  },
  {
    question: "How are the sessions conducted?",
    answer:
      "Live and interactive. Your team learns in real-time cohorts with direct access to mentors, doubt-solving clinics and recordings for anyone who misses a session. We also offer on-site delivery at your office, corporate offsites, and blended self-paced tracks.",
  },
  {
    question: "Is the program completely online?",
    answer:
      "You choose. Fully online, fully on-site, offsite immersions or blended. Every model runs the same 80/20 practical curriculum.",
  },
  {
    question: "What happens if someone on our team cannot attend a session?",
    answer:
      "Recordings are shared with your L&D team so nobody falls behind. Live doubt clinics run weekly so missed sessions can be caught up without breaking momentum.",
  },
  {
    question: "How long does a program run?",
    answer:
      "Most programs run 3 to 6 weeks. Leadership intensives can be as short as 2 days. Full technical bootcamps go up to 12 weeks. We recommend the right length on the discovery call.",
  },
  {
    question: "What is the minimum team size?",
    answer:
      "We typically start at 20 learners. Smaller teams can blend into an open enterprise cohort at a lower per-seat cost.",
  },
  {
    question: "Can you train teams outside India?",
    answer:
      "Yes. We deliver for teams in Singapore, Dubai, London and the US. Every delivery model is time-zone flexible.",
  },
  {
    question: "Do you sign NDAs and handle sensitive data securely?",
    answer:
      "Always. We work with BFSI, healthcare and defence-adjacent clients. Standard NDAs, MSAs and data protocols are in place before the first session.",
  },
  {
    question: "How do you measure ROI?",
    answer:
      "Pre and post skill assessments, live project outcomes, self-reported productivity deltas, and for clients who want it, a 90-day outcomes audit done directly with your managers.",
  },
  {
    question: "What does it cost?",
    answer:
      "Pricing is custom and depends on team size, delivery model and how much customisation you want. We share a clear proposal within 48 hours of the discovery call. No surprises.",
  },
  {
    question: "What do we need to get started?",
    answer:
      "One call. We handle the rest.",
  },
];

const bootcamp3DayFaqs = [
  {
    question: "What does the Bootcamp cost?",
    answer:
      "₹9,999 in India, $999 internationally. One payment. Every session, every recording, every file included.",
  },
  {
    question: "How is this different from the free 2-Day Mastermind?",
    answer:
      "The Mastermind shows you what Gen AI can do. The Bootcamp is where you build with it. Twenty hours instead of sixteen. Seven sessions instead of five. Two of those sessions, AI Workflows & Connectors and autonomous agents on n8n, are not in the free programme at all. You leave the Mastermind with notes. You leave the Bootcamp with a live web app, a working agent, an AI assistant and an ad film.",
  },
  {
    question: "Do I need to know how to code?",
    answer:
      "No. Not a single session requires it. You will deploy a working web app and an autonomous agent without writing code. If you already code, you will move faster and the n8n and API work will take you further.",
  },
  {
    question: "Day 3 is only three hours. Is this really three days?",
    answer:
      "Day 1 and Day 2 run 10:00 AM to 7:00 PM. Day 3 is a focused three-hour evening session, because the creative work lands better as one block than as a padded day. Twenty hours of live instruction in total. We would rather tell you that than sell you filler.",
  },
  {
    question: "What do I actually walk away with?",
    answer:
      "A deployed web app. An autonomous n8n agent running a real process. An AI assistant grounded in your own documents. An HD ad film. And a prompt library you will use every week after.",
  },
  {
    question: "Is it live or recorded?",
    answer: "Live. Every session, every mentor, in the room with you.",
  },
  {
    question: "What are the timings?",
    answer:
      "All sessions run on IST. Day 1 and Day 2 are 10:00 AM to 7:00 PM IST. Day 3 is 7:00 PM to 10:00 PM IST.",
  },
  {
    question: "Is there a certificate?",
    answer: "Yes. You get it for what you build, not for showing up.",
  },
];

export const faqsBySlug = {
  "": mastermindFaqs, // homepage when slug = "/"
  "2-day-ai-mastermind": mastermindFaqs,
  "6-month-ai-generalist-fellowship": fellowshipFaqs,
  "6-month-ai-engineering": engineerFaqs,
  "2-day-ai-engineering-mastermind": engineerMastermindFaqs,
  "ai-tools-deepdive": toolsFaqs,
  "ai-generalist-bootcamp": bootcampFaqs,
  "3-day-generative-ai-bootcamp": bootcamp3DayFaqs,
  "ai-accelerator": acceleratorFaqs,
  "engineering-accelerator": engAcceleratorFaqs,
  business: businessFaqs,
};
